import { createFileRoute } from '@tanstack/react-router';

import { GHGDashboardContent } from '@/features/ghg/components/GHGDashboardContent';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/overview')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.ghgOverview'),
  }),
  component: GHGOverviewPage,
});

function GHGOverviewPage() {
  return <GHGDashboardContent />;
}
